export default "__VITE_ASSET__BDqbMsc$__"